<template>
	<div class="has-text-centered box" v-if="images?.length">
		<images-carousel
			:images="images"
			:initialIndex="currentSlide"
			:withThumbnails="true"
			:onImageClick="openFullscreenSlider"
		></images-carousel>

		<span class="is-size-7">Click an image for fullscreen mode</span>
	</div>
</template>
<script lang="ts">
import { ImagesModalMixin } from "@/utils/mixins";
import { defineComponent } from "vue";
import ModalManager from "@/utils/modal";

export default defineComponent({
	mixins: [ImagesModalMixin],
	methods: {
		openFullscreenSlider (image: string) {
			ModalManager.openFullscreenImages(image, () => {})
		}
	}
})
</script>

<style scoped>
	.box {
		max-height: 80vh;
		overflow: scroll;
	}
</style>
